<template>
	<div class="event-card full-width q-px-sm q-pb-md">
		<div class="row gutter-xs">
			<div class="col-12" v-if="renderPresentialEventCatalogCode()">
				<q-input v-model="presential_event_catalog_code" ref="presential_event_catalog_code"
					:float-label="$t('course_catalog_code')" @clear="removeCatalogCode" filter autofocus-filter
					clearable :error="$v.presential_event_catalog_code.$error"
					@input="$v.presential_event_catalog_code.$touch">
					<q-autocomplete @search="fetchCatalogCodes" @selected="selectCatalogCode" :debounce="500"
						:min-characters="1" :max-results="100" :value-field="(v) => `${v.code}`" />
				</q-input>
			</div>

			<div class="col-12">
				<q-field>
					<q-input v-model="user_requester_name_email" :float-label="$t('requester')" disable readonly />
				</q-field>
			</div>

			<div class="col-12">
				<q-field :count="256">
					<q-input v-model="title" ref="title" :float-label="$t('title')" :error="$v.title.$error"
						@input="$v.title.$touch"
						:disable="disableBasicData || !permissions.presential_edit_basic_data" />
				</q-field>
			</div>

			<div class="col-12">
				<span class="caption q-mb-sm block">{{ $t('introduction') }}</span>
				<q-field :count="1024">
					<q-input v-model="descriptionWithoutHTML" style="display: none;"></q-input>
					<q-editor :content-style="contentStyleDescription" v-model="description"
						@input="$v.descriptionWithoutHTML.$touch"
						:disable="disableBasicData || !permissions.presential_edit_basic_data" :toolbar="[
				['bold', 'italic', 'strike', 'underline'],
				['left', 'center', 'right', 'justify'],
				['link', 'upload'],
				[
					{
						label: null,
						icon: 'fas fa-font',
						fixedLabel: true,
						fixedIcon: true,
						list: 'no-icons',
						options: [
							'p',
							'h1',
							'h2',
							'h3',
							'h4',
							'h5',
							'h6',
							'code',
						],
					},
					{
						label: null,
						icon: 'fas fa-text-height',
						fixedLabel: true,
						fixedIcon: true,
						list: 'no-icons',
						options: [
							'size-1',
							'size-2',
							'size-3',
							'size-4',
							'size-5',
							'size-6',
							'size-7',
						],
					},
					'removeFormat',
				],
				['quote', 'unordered', 'ordered'],
				['custom_btn'],
			]" :definitions="{
				bold: { label: null, icon: 'fas fa-bold' },
				italic: { label: null, icon: 'fas fa-italic' },
				strike: { label: null, icon: 'fas fa-strikethrough' },
				underline: { label: null, icon: 'fas fa-underline' },
				left: { label: null, icon: 'fas fa-align-left' },
				center: { label: null, icon: 'fas fa-align-center' },
				right: { label: null, icon: 'fas fa-align-right' },
				justify: { label: null, icon: 'fas fa-align-justify' },
				link: { label: null, icon: 'fas fa-link' },
				upload: {
					tip: null,
					icon: 'fas fa-file-image',
					handler: insertImg,
				},
				removeFormat: { label: null, icon: 'fas fa-eraser' },
				quote: { label: null, icon: 'fas fa-quote-right' },
				unordered: { label: null, icon: 'fas fa-list-ul' },
				ordered: { label: null, icon: 'fas fa-list-ol' },
			}">
						<q-btn slot="custom_btn" dense flat color="black" icon="fal fa-code" label="HTML"
							@click="show_description_html = true" />
					</q-editor>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="current_client !== 'universidadechevrolet' && current_client === 'academiacoral'
				">
				<q-field :warning="hasTrainingCode" :helper="`${trainings_code.length > 1
				? $t('there_are_trainings_that_use_this_code')
				: $t('presential_code_helper_message')
				}`
				">
					<q-input :loading="loading_code" type="text" v-model="code" :float-label="$t('training_code')"
						:disable="disableBasicData || !permissions.presential_edit_basic_data" @blur="searchCode" />
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="hasTrainingCode">
				<q-btn color="secondary" size="small" :label="$t('trainings')" @click="show_modal = true" />
			</div>

			<div class="col-12">
				<q-select v-model="appointment_type_id" ref="appointment_type_id" :options="appointment_types"
					:float-label="$t('appointment_type')" :error="$v.appointment_type_id.$error"
					@input="updateParticipantsAndValidate"
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input :value="minimumParticipants" :float-label="$t('minimum_participants')" disable />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input :value="maximumParticipants" :float-label="$t('maximum_participants')" disable />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input :value="individualValue" :float-label="$t('individual_value')" prefix="$" disable />
			</div>

			<div class="col-12">
				<q-chips-input v-model="instructors_labels" ref="instructors_labels" :float-label="$t('instructor')"
					:debounce="600" @remove="removeInstructor" clearable :error="$v.instructors.$error"
					@input="$v.instructors.$touch"
					:disable="disableBasicData || !permissions.presential_edit_basic_data">
					<q-autocomplete @search="searchInstructor" @selected="selectInstructor" :min-characters="3"
						:max-results="30" :value-field="(v) => `${v.label}`" />
				</q-chips-input>
			</div>

			<div class="col-12">
				<q-input v-model="company_branch_name" ref="company_branch" :float-label="$t('location_name')"
					autocomplete="new-password" :debounce="600" @clear="removeBranch" clearable
					:error="$v.company_branch.$error" @input="$v.company_branch.$touch"
					:disable="disableBasicData || !permissions.presential_edit_basic_data">
					<q-autocomplete @search="searchBranch" :min-characters="3" :max-results="50"
						@selected="selectBranch" :value-field="(e) =>
				`${e.name} ${e.fantasy ? ' / ' + e.fantasy : ''} ${e.document ? e.document : ''
				} / ${e.address.address}${e.address.number ? ', ' + e.address.number : ''
				} - ${e.address.city}/${e.address.state}`
				" separator />
				</q-input>
			</div>

			<div class="col-12">
				<q-input v-model="company_branch_address" :float-label="$t('address')" disable />
			</div>

			<div v-if="current_client === 'academiacoral'" class="col-12">
				<q-input v-model="partner_name" :float-label="$t('partner_branch')" autocomplete="new-password"
					:debounce="600" @clear="removePartner" clearable
					:disable="disableBasicData || !permissions.presential_edit_basic_data">
					<q-autocomplete @search="searchPartner" :min-characters="3" :max-results="50"
						@selected="selectPartner" :value-field="(e) =>
				`${e.name} ${e.fantasy ? ' / ' + e.fantasy : ''} ${e.document ? e.document : ''
				} / ${e.address.address}${e.address.number ? ', ' + e.address.number : ''
				} - ${e.address.city}/${e.address.state}`
				" separator />
				</q-input>
			</div>

			<div class="col-12">
				<q-select v-model="timezone" :options="timezones" :float-label="$t('timezone')"
					@input="changeTimezone()" filter
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-12 q-mt-md">
				<p class="caption q-mb-xs">{{ $t('categories_modules') }}</p>
				<q-checkbox class="q-mb-xs" :disable="disableBasicData || !permissions.presential_edit_basic_data"
					v-model="all_product_categories" :val="true" :label="$t('select_all_categories_modules')"
					@input="checkAllCategories()" />

				<q-select v-model="product_categories" ref="product_categories" :options="product_categories_list.map((e) => {
				return { value: e.value, label: e.title }
			})
				" multiple chips filter :error="$v.product_categories.$error" @input="changeProducts"
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-12 q-mt-md">
				<p class="caption q-mb-xs">{{ $t('products_themes') }}</p>
				<q-checkbox class="q-mb-xs" :disable="product_categories.length < 1 ||
				disableBasicData ||
				!permissions.presential_edit_basic_data
				" v-model="all_products" :val="true" :label="$t('select_all_product_themes')" @input="checkAllProducts()" />
				<q-select v-model="products" ref="products" :options="filteredProducts" multiple chips filter
					:error="$v.products.$error" @input="$v.products.$touch"
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-input type="number" ref="qty_expected_participants" v-model="qty_expected_participants"
					:float-label="$t('expected_participants')" :error="$v.qty_expected_participants.$error"
					@input="$v.qty_expected_participants.$touch"
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input type="number" v-model="score" :float-label="$t('score')" :error="$v.score.$error"
					@input="$v.score.$touch" :disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input ref="workload" type="number" v-model="workload" :float-label="$t('workload_in_hours')"
					:error="$v.workload.$error" @input="$v.workload.$touch"
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select v-model="tags" :options="optionTags" :float-label="$t('tags')" multiple chips filter
					autofocus-filter :disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div :class="current_client === 'academiacoral' ? 'col-xs-5 col-sm-5' : 'col-xs-6 col-sm-6'
				">
				<q-select v-model="presential_event_type" :error="!presential_event_type ? true : false" :options="presential_event_types.map((e) => ({ label: $t(e.slug), value: e.value }))
				" :float-label="$t('training_type')" :disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div style="padding: 10px 2px;">
				<q-icon name="fal fa-question-circle" size="1.5rem" color="grey" class="q-mr-sm q-pt-md">
					<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
						{{ getEventTypeTooltip(presential_event_type) }}
					</q-tooltip>
				</q-icon>
			</div>

			<div v-if="current_client === 'academiacoral'" class="col-xs-5 col-sm-5">
				<q-select v-model="is_listed" :options="listed_training_types" :float-label="$t('training_listing')"
					:disable="disableBasicData || !permissions.presential_edit_basic_data" />
			</div>

			<div v-if="current_client === 'academiacoral'" style="padding: 10px 2px;">
				<q-icon name="fal fa-question-circle" size="1.5rem" color="grey" class="q-mr-sm q-pt-md">
					<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
						{{ $t('training_listing_type_tooltip') }}
					</q-tooltip>
				</q-icon>
			</div>

			<inputExpireCertificate :disableInput="disableBasicData || !permissions.presential_edit_basic_data"
				@fnInDays="fnInDays" :qty_days="qty_days" ref="inputExpireCertificate"
				v-if="selected_client_params.use_presential_events_certificate_expiration" />

			<div class="col-12 q-mb-md">
				<div class="row gutter-sm">
					<div class="col-12" v-if="id != 0 && isBoticario">
						<p class="caption">{{ $t('certificate') }}</p>
						<uploader content_type="images" @fileUploaded="certificateImageUploaded" :multiple="false"
							filename="certificate" :id="id" custom_certificate_module_path="presential_event"
							:disable="disableBasicData || !permissions.presential_edit_basic_data" />

						<p v-if="certificate_image_url" class="q-mt-md file-url">
							<q-icon name="fal fa-check" color="positive" />
							<a :href="certificate_image_url" target="_blank"> {{ $truncateLink(certificate_image_url)
								}}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6 q-mt-xs">
						<p class="caption">{{ $t('image') }}</p>
						<uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="true"
							:aspect_ratio="52 / 29" :aspect_ratio_string="'52/29'"
							:disable="disableBasicData || !permissions.presential_edit_basic_data" />
						<!-- :disable="disableBasicData" -->

						<p v-if="image_url_presential_event" class="q-mt-md file-url">
							<q-icon name="fal fa-check" color="positive" />
							<a :href="image_url_presential_event" target="_blank">
								{{ $truncateLink(image_url_presential_event) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							{{ $t('alt_image') }}
							<q-icon name="fal fa-question-circle" size="1.5rem" color="grey" class="q-ml-sm q-pb-sm">
								<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
									{{ $t('alt_image_information_helper') }}
								</q-tooltip>
							</q-icon>
						</p>
						<div class="flex justify-between">
							<template v-for="lang in languages" class="row flex">
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'pt-br'">
									<q-input v-model="language_br" :float-label="$t(`${lang.name}`)" ref="language_br"
										:error="$v.language_br.$error" @input="$v.language_br.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'en-us'">
									<q-input v-model="language_us" :float-label="$t(`${lang.name}`)" ref="language_us"
										:error="$v.language_us.$error" @input="$v.language_us.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'es-es'">
									<q-input v-model="language_es" :float-label="$t(`${lang.name}`)" ref="language_es"
										:error="$v.language_es.$error" @input="$v.language_es.$touch" />
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'fr-fr'">
									<q-input v-model="language_fr" :float-label="$t(`${lang.name}`)" ref="language_fr"
										:error="$v.language_fr.$error" @input="$v.language_fr.$touch" />
								</q-field>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>

		<q-tabs v-model="tab_permission" color="secondary" class="shadow-1 q-mt-md">
			<q-tab slot="title" name="permissions" icon="fal fa-user-check" :label="$t('target_audience')" />

			<q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('areas') }}</p>
						<q-checkbox class="q-mb-sm"
							:disable="disableBasicData || !permissions.presential_edit_basic_data" v-model="all_areas"
							:val="true" :label="$t('select_all_areas')" @input="checkAllAreas()" />
						<select-multiple label="" :filters="area" :options="areas" @on_value="area = $event"
							:error="$v.area.$error" :input="$v.area.$touch"
							:disable="disableBasicData || !permissions.presential_edit_basic_data" />
					</div>

					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('profiles') }}</p>

						<div class="row gutter-sm">
							<div class="col-xs-12 col-sm-12">
								<q-checkbox v-model="all_profiles" :val="true" :label="$t('all')" @input="checkAll()"
									:disable="disableBasicData || !permissions.presential_edit_basic_data
				" />
							</div>

							<div class="col-xs-12 col-sm-4" v-for="(item, index) in profiles" :key="index"
								:class="getErrorClass($v.profile.$error)">
								<q-checkbox keep-color v-model="profile" ref="profile" :val="item.value"
									:label="item.label" @input="$v.profile.$touch"
									:color="getErrorColor($v.profile.$error)" :disable="disableBasicData || !permissions.presential_edit_basic_data
				" />
							</div>
						</div>
					</div>
				</div>
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<q-select filter autofocus-filter v-model="user_group" ref="user_group" :options="user_groups"
							:float-label="$t('user_groups')" :error="$v.user_group.$error" @input="$v.user_group.$touch"
							multiple chips :disable="disableBasicData || !permissions.presential_edit_basic_data" />
					</div>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-chips-input v-model="companies_label" ref="companies_label" :float-label="$t('headquarters')"
						:debounce="600" @remove="removeHeadquarter" clearable :error="$v.company.$error"
						@input="$v.company.$touch"
						:disable="disableBasicData || !permissions.presential_edit_basic_data">
						<q-autocomplete @search="fetchHeadquarters" @selected="selectHeadquarter" :min-characters="1"
							:max-results="100" />
					</q-chips-input>
				</div>

				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<q-select filter autofocus-filter v-model="branch" ref="branch" :options="branches"
							:float-label="$t('branches')" :error="$v.branch.$error" @input="
				current_client === 'universidadechevrolet'
					? addVacancies(branch)
					: null
				" multiple chips :readonly="disableBasicData" :disable="company.length > 0
				? false
				: true ||
				disableBasicData ||
				!permissions.presential_edit_basic_data
				" />
					</div>
				</div>

				<div v-if="current_client === 'universidadechevrolet' && branch.length > 0"
					class="q-mt-md col-xs-12 col-sm-12">
					<p class="caption q-mt-lg">{{ $t('vacancy_division') }}</p>
					<div class="row gutter-sm q-pb-sm">
						<div class="col-xs-12" v-for="(item, index) in vacancies" :key="`va${index}`">
							<q-input class="custom-input" outlined v-model="item.qty_vacancies" type="number"
								:prefix="`${item.label}: `" @blur="checkVacancies" />
						</div>
					</div>
				</div>

				<div class="row gutter-sm q-my-sm" v-if="id != 0 && status !== 9">
					<div class="col-xs-12 col-sm-11">
						<q-input v-model="url_presential_training" :float-label="$t('link')" :disable="true" />
					</div>

					<div class="col-xs-12 col-sm-1 q-mt-lg">
						<q-btn dense color="primary" icon="fal fa-copy" class="full-width" @click="copyLink()">
							<q-tooltip>
								{{ $t('copy_link') }}
							</q-tooltip>
						</q-btn>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')" v-if="showSaveAsModel">
				<q-btn color="secondary" class="full-width" :label="$t('save_as_model')" icon="fal fa-file-user"
					@click="save_as_model_dialog = true" />
			</div>
			<div class="col-xs-12 col-sm-3" :class="getOrder('save')" v-if="showSaveBasicData">
				<q-btn color="secondary" class="full-width" :label="status === 9 ? $t('save_model') : $t('save')"
					icon="far fa-save" @click="saveData()" />
			</div>
		</div>

		<q-modal v-model="show_modal" :content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			@hide="show_modal = false" no-backdrop-dismiss no-esc-dismiss>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('trainings') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table :data="trainings_code" :columns="columns" row-key="index">
						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>
						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width key="title" :props="props">
								{{ props.row.title }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="save_as_model_dialog" prevent-close>
			<span slot="title">{{ $t('save_as_model') }}</span>

			<span slot="message">{{ $t('do_you_confirm_saving_as_model') }}</span>

			<template slot="buttons" slot-scope="props">
				<q-btn color="tertiary" :label="$t('cancel')" @click="save_as_model_dialog = false" />
				<q-btn color="positive" :label="$t('save')" @click="saveAsModel()" />
			</template>
		</q-dialog>
		<q-modal v-model="show_description_html"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }" no-backdrop-dismiss
			no-esc-dismiss>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_description_html = false" icon="fas fa-times" />
					<q-toolbar-title>
						HTML
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row">
						<div class="col-12">
							<q-input type="textarea" rows="10" float-label="HTML" v-model="description" />
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-ban"
								@click="show_description_html = false" />
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, minValue, maxLength, requiredIf } from 'vuelidate/lib/validators'
import { date, debounce } from 'quasar'
const { formatDate } = date
import Uploader from 'components/Uploader'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

import InputExpireCertificate from 'components/admin/shared/InputExpireCertificate'
import SelectMultiple from 'components/utils/SelectMultiple'

export default {
	name: 'AdminPresentialBasicData',

	props: ['current_client', 'full_name', 'permissions', 'auto_duplicate'],

	data() {
		return {
			language_br: '',
			language_us: '',
			language_es: '',
			language_fr: '',
			id: 0,
			user_requester_name_email: '',
			title: '',
			description: '',
			score: 0,
			code: null,
			workload: 0,
			all_areas: false,
			all_product_categories: false,
			all_products: false,
			area: [],
			profile: [],
			user_group: [],
			company: [],
			branches: [],
			qty_days_result_expiration: 0,
			qty_days: null,
			branch: [],
			tab_permission: 'permissions',
			all_profiles: false,
			tags: [],
			companies: [],
			companies_label: [],
			company_branches: [],
			company_branch: '',
			company_branch_name: '',
			company_branch_address: '',
			instructors_labels: [],
			instructors: [],
			qty_expected_participants: 1,
			appointment_type_id: '',
			status: '',
			product_categories: [],
			products: [],
			image_url_presential_event: '',
			certificate_image_url: '',
			presential_event_images: [],
			timezone: '',
			presential_event_type: 1,
			trainings_code: [],
			loading_code: false,
			show_modal: false,
			columns: [
				{
					name: 'title',
					required: true,
					label: 'title',
					align: 'left',
					field: 'title',
					sortable: true,
				},
			],
			save_as_model_dialog: false,
			save_as_model: false,
			vacancies: [],
			vacancies_used: 0,
			vacancies_qty: [],
			// Academia Coral only
			is_listed: false,
			listed_training_types: [
				{ label: this.$t('not_listed_training'), value: false },
				{ label: this.$t('listed_training'), value: true },
			],
			partner: '',
			partners: [],
			partner_name: '',
			presential_event_catalog: '',
			presential_event_catalog_code: '',
			presential_event_catalog_title: '',
			selected_client_params: [],
			show_description_html: false,
		}
	},

	components: {
		uploader: Uploader,
		inputExpireCertificate: InputExpireCertificate,
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			appointment_types: 'registration_lists/appointment_types',
			areas: 'registration_lists/country_areas',
			email_store: 'common/email',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			name_store: 'common/full_name',
			presential_event_types: 'registration_lists/presential_event_types',
			product_categories_list: 'registration_lists/product_categories',
			products_list: 'registration_lists/products',
			profiles: 'registration_lists/profiles',
			register_fields: 'params/register_fields',
			register_profiles: 'registration_lists/register_profiles',
			tags_list: 'registration_lists/tags',
			timezones: 'registration_lists/timezones',
			user_groups: 'registration_lists/group_users',
			user_module_items: 'common/user_module_items',
			languages: 'params/languages',
			id_user_client_selected: 'common/id_user_client_selected',
			clients: 'params/clients',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		optionTags() {
			if (this.tags_list.length > 0) {
				return this.tags_list.map((t) => {
					let areas = t.areas.map((a) => a.name)
					return {
						value: t.value,
						label: t.label,
						sublabel: areas.join(', '),
					}
				})
			} else return []
		},

		filteredProducts() {
			return this.products_list
				? this.products_list.filter((p) =>
					this.product_categories.includes(p.product_category)
				)
				: []
		},

		disableBasicData() {
			return this.status === 1 || this.status === 6 || this.status === 9 || this.id == 0
				? false
				: true
		},

		showSaveBasicData() {
			if (this.status === 9) {
				return this.permissions.manage_models ? true : false
			} else {
				if (this.permissions.presential_edit_basic_data) {
					if (this.status === 1 || this.status === 6 || this.id == 0) return true
				} else return false
			}
		},

		showSaveAsModel() {
			if (this.permissions.manage_models) {
				if (this.id !== 0) return false
				else return true
			} else return false
		},

		minimumParticipants() {
			if (this.appointment_type_id && this.appointment_types) {
				const obj = this.appointment_types.find(
					(obj) => obj.value === this.appointment_type_id
				)
				if (obj) return obj.mininum_participants_qty
			}
			return 0
		},

		maximumParticipants() {
			if (this.appointment_type_id && this.appointment_types) {
				const obj = this.appointment_types.find(
					(obj) => obj.value === this.appointment_type_id
				)
				if (obj) return obj.maximum_participants_qty
			}
			return 50
		},

		individualValue() {
			if (this.appointment_type_id && this.appointment_types) {
				let obj = this.appointment_types.find(
					(obj) => obj.value === this.appointment_type_id
				)
				if (obj) return obj.individual_value
			}
			return 0
		},

		hasTrainingCode() {
			return this.trainings_code.length > 1 ? true : false
		},

		getMaxWidth() {
			return this.$q.platform.is.mobile ? '100vw' : '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		url_presential_training: {
			get() {
				const url = process.env.SITE_URL ? process.env.SITE_URL : document.location.origin
				return `${url}/presential-courses/${this.id}`
			},
			set() {
				''
			},
		},
		descriptionWithoutHTML() {
			let decodedHtml = this.description.replace(/&nbsp;/g, " ")
				.replace(/&amp;/g, "&")
				.replace(/&quot;/g, "\"")
				.replace(/&lt;/g, "<")
				.replace(/&gt;/g, ">");
			return decodedHtml.replace(/<\/?[^>]+(>|$)/g, "")
		},
		isBoticario() {
			return process.env.PROJECT_FOLDER == 'acelera'
		},

		contentStyleDescription() {
			if (this.$v.descriptionWithoutHTML.$error) return { border: '1px solid red' }
			return {}
		}
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/presential/presential_events/${this.id}/`, this.getHeader)
				.then((response) => {
					let d = response.data
					this.qty_days = d.qty_certificate_expiration_days
					this.user_requester_name_email = d.user_requester_name_email
					this.title = d.title
					this.description = d.description
					this.score = d.score
					this.workload = d.workload
					this.presential_event_images = d.presential_event_images
					this.company_branch = d.company_branch
					this.company_branch_name =
						d.company_branch_name && d.company_branch_fantasy
							? `${d.company_branch_name} / ${d.company_branch_fantasy}`
							: d.company_branch_name
					this.company_branch_address = `${d.address.address}${d.address.number ? ', ' + d.address.number : ''
						} - ${d.address.city}/${d.address.state}`
					this.instructors = d.instructors_list.map((e) => e.id)
					this.instructors_labels = d.instructors_list
						? d.instructors_list.map((e) => {
							return `${e.name} - ${e.email}`
						})
						: []
					this.qty_expected_participants = d.qty_expected_participants
					this.appointment_type_id = d.appointment_type_id
					this.status = d.status
					this.product_categories = d.product_categories.map((e) => {
						return e.id
					})
					this.products = d.products.map((e) => {
						return e.product_id
					})
					this.tags = d.tags.map((e) => {
						return e.id
					})
					this.timezone = d.timezone
					this.code = d.code
					this.presential_event_type = d.presential_event_type
					this.area = d.areas
					this.profile = d.profiles
					this.user_group = d.user_groups
					this.company = d.companies
					this.branch = d.company_branches
					this.save_as_model = d.status === 9 ? true : false
					this.is_listed = d.is_listed ? d.is_listed : false
					this.partner = d.partner ? d.partner : ''
					this.partner_name =
						d.partner_name && d.partner_fantasy
							? `${d.partner_name} / ${d.partner_fantasy}`
							: d.partner_name
								? d.partner_name
								: ''
					this.presential_event_catalog_code = d.code
					this.presential_event_catalog = d.presential_catalog

					if (d.vacancies && d.vacancies.length > 0) {
						this.vacancies_qty = d.vacancies.map((v) => v.qty_vacancies)
					}

					this.payment_installments =
						d.qty_payment_installments === 1
							? false
							: d.qty_payment_installments === 3
								? true
								: null

					if (d.presential_image_alt_text) {
						const altTextMap = {}
						d.presential_image_alt_texts.forEach((altTextObj) => {
							altTextMap[altTextObj.language] = altTextObj.alt_text
						})
						this.language_br = altTextMap['pt-br'] || ''
						this.language_us = altTextMap['en-us'] || ''
						this.language_es = altTextMap['es-es'] || ''
						this.language_fr = altTextMap['fr-fr'] || ''
					}

					if (d.companies && d.companies.length) {
						d.companies.forEach((company) => {
							let match = d.companies_list.find((obj) => obj.id === company)
							if (match) {
								let label = `${match.name} ${match.document ? '/ ' + match.document : ''
									}`
								this.companies_label.push(label)
							}
						})
					}

					this.changeTimezone()

					if (this.company.length) this.loadBranches()
					if (this.code) this.searchCode()

					this.$emit('updateEventsInfo', {
						id: this.id,
						status: this.status,
						title: this.title,
						description: this.description,
						liveClassIsPublic: this.presential_event_type === 1 ? true : false,
						maxParticipants: this.maximumParticipants,
						allowed_areas: this.area.length ? this.area : this.areas,
						allowed_profiles: this.profile.length ? this.profile : this.profiles,
					})

					const obj_img = d.presential_event_images.find((obj) => obj.original === true)
					if (obj_img) this.image_url_presential_event = obj_img.image

					if (this.isBoticario && this.id != 0) {
						this.certificate_image_url = `${process.env.SITE_URL}/${d.presential_event_certificate_image_url}`
					}

					if (this.auto_duplicate) this.$emit('autoDuplicateTraining', true)

					if (this.current_client === 'academiacoral') {
						if (this.status === 1) {
							if (
								this.appointment_type_id === 17 ||
								this.instructor_name ===
								'[CONSULTOR: SELECIONAR] - selecione-seu-nome@ac.com.br'
							) {
								this.$emit('AcademiaCoralApprovalHandler', false)
							}
						}
					}

					if (this.status === 1) this.checkUserAllowed()
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					if (this.$route.params.customTab) {
						this.$route.params.customTab = false
						this.$emit('changeTab', 'guests')
					}
					this.$q.loading.hide()
				})
		},

		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let data = {
					title: this.title,
					description: this.description ? this.description : null,
					company_branch: this.company_branch,
					instructors: this.instructors,
					qty_expected_participants: this.qty_expected_participants,
					appointment_type_id: this.appointment_type_id,
					product_categories: this.product_categories,
					products: this.products,
					score: this.score,
					code: this.code ? this.code : this.presential_event_catalog_code,
					presential_catalog: this.presential_event_catalog
						? this.presential_event_catalog
						: null,
					workload: this.workload,
					timezone: this.timezone,
					presential_event_type: this.presential_event_type,
					image_url_presential_event: this.image_url_presential_event,
					presential_image_alt_texts: {
						'pt-br': this.language_br ? this.language_br : '',
						'en-us': this.language_us ? this.language_us : '',
						'es-es': this.language_es ? this.language_es : '',
						'fr-fr': this.language_fr ? this.language_fr : '',
					},
				}
				if (this.$refs.inputExpireCertificate) {
					this.$refs.inputExpireCertificate.updateTypeCalendar(1)
				}

				data.qty_certificate_expiration_days =
					this.qty_days_result_expiration == 0
						? null
						: this.qty_days_result_expiration

				if (this.save_as_model) {
					data.status = 9
				}

				if (this.tags.length) {
					data.tags = this.tags
				}

				if (this.area.length > 0 || this.profile.length > 0) {
					data.areas = this.area
					data.profiles = this.profile
				}

				if (this.user_group.length > 0) {
					data.user_groups = this.user_group
				}

				if (this.branch.length > 0 || this.company.length > 0) {
					data.company_branches = this.branch
					data.companies = this.company
				}

				if (this.current_client === 'academiacoral') {
					data.is_listed = this.is_listed
					data.partner = this.partner
					if (this.status === 1) {
						let check = this.coralCheckSave(this.appointment_type_id)
						if (!check) {
							this.$q.loading.hide()
							return
						}
					}
				}

				if (this.isBoticario && this.id !== 0 && this.certificate_image_url) {
					data.presential_event_certificate_image_url = this.certificate_image_url
				}

				if (this.current_client === 'universidadechevrolet' && this.branch.length > 0) {
					if (this.branch.length > 0) {
						this.checkVacancies()

						if (!this.checkVacancies()) {
							this.$q.notify({
								message: this.$t('vacancy_limit_info'),
								type: 'negative',
								icon: 'fal fa-exclamation-triangle',
							})
							this.$q.loading.hide()
							return
						}

						if (this.vacancies_used !== 0 && this.checkVacancies()) {
							data.vacancies = this.vacancies
						}
					}
				}

				if (this.id == 0) {
					this.$axios
						.post(`/presential/presential_events/`, data, this.getHeader)
						.then((response) => {
							this.id = response.data.id
							this.$router.replace({ name: 'appointment', params: { id: this.id } })
							this.status = response.data.status

							this.$emit('updateEventsInfo', {
								id: this.id,
								status: this.status,
								title: this.title,
								description: this.description,
								liveClassIsPublic: this.presential_event_type === 1 ? true : false,
								maxParticipants: this.maximumParticipants,
								allowed_areas: this.area.length ? this.area : this.areas,
								allowed_profiles: this.profile.length
									? this.profile
									: this.profiles,
							})

							if (this.status === 9) {
								this.$q.notify({
									message: this.$t('model_save_success'),
									type: 'positive',
									icon: 'fal fa-save',
								})
							} else {
								this.$q.notify({
									message: this.$t('appointment_save_success'),
									type: 'positive',
									icon: 'fal fa-save',
								})
							}
						})
						.catch((e) => {
							console.log(e)

							if (this.status === 9) {
								this.$q.notify({
									message: this.$t('model_save_error'),
									type: 'negative',
									icon: 'fal fa-ban',
								})
							} else {
								this.$q.notify({
									message: this.$t('appointment_save_error'),
									type: 'negative',
									icon: 'fal fa-ban',
								})
							}
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				} else {
					this.$axios
						.put(`/presential/presential_events/${this.id}/`, data, this.getHeader)
						.then((response) => {
							this.status = response.data.status

							this.$emit('updateEventsInfo', {
								id: this.id,
								status: this.status,
								title: this.title,
								description: this.description,
								liveClassIsPublic: this.presential_event_type === 1 ? true : false,
								maxParticipants: this.maximumParticipants,
								allowed_areas: this.area.length ? this.area : this.areas,
								allowed_profiles: this.profile.length
									? this.profile
									: this.profiles,
							})

							if (this.status === 9) {
								this.$q.notify({
									message: this.$t('model_save_success'),
									type: 'positive',
									icon: 'fal fa-save',
								})
							} else {
								this.$q.notify({
									message: this.$t('appointment_save_success'),
									type: 'positive',
									icon: 'fal fa-save',
								})
							}
						})
						.catch((e) => {
							console.log(e)

							if (this.status === 9) {
								this.$q.notify({
									message: this.$t('model_save_error'),
									type: 'negative',
									icon: 'fal fa-ban',
								})
							} else {
								this.$q.notify({
									message: this.$t('appointment_save_error'),
									type: 'negative',
									icon: 'fal fa-ban',
								})
							}
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				}
			} else {
				this.$formInputErrorFocus(this.$v, this.$refs, 'profile')

				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		saveAsModel() {
			this.save_as_model_dialog = false
			this.$v.$touch()
			if (!this.$v.$error) {
				this.save_as_model = true
				this.saveData()
			}
		},

		searchInstructor(terms, done) {
			this.$axios
				.get(`/accounts/get_instructors/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = response.data.map((e) => {
						return {
							value: e.id,
							label: `${e.full_name} - ${e.email}`,
							full_name: e.full_name,
							email: e.email,
						}
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		autoSelectInstructor(name) {
			this.$axios
				.get(`/accounts/get_instructors/?search=${name}`, this.getHeader)
				.then((response) => {
					let users = response.data.map((e) => {
						return {
							value: e.id,
							label: `${e.full_name} - ${e.email}`,
							full_name: e.full_name,
							email: e.email,
						}
					})
					if (users.length === 1) {
						let user = users[0]
						this.instructors_labels.push(user.label)
						this.instructors.push(user.value)
					} else return
				})
				.catch((e) => {
					console.log(e)
				})
		},

		selectInstructor(item, keyboard) {
			if (!keyboard) {
				this.instructors.push(item.value)
			}
		},

		removeInstructor({ index, value }) {
			this.instructors.splice(index, 1)
			this.instructors_labels.splice(index, 1)
		},

		searchBranch(terms, done) {
			this.$axios
				.get(`/admin_companies/branches/get_branches/?search=${terms}`, this.getHeader)
				.then((response) => {
					let branches = response.data.map((e) => {
						return {
							...e,
							value: e.id,
							label: `${e.name} ${e.fantasy ? ' / ' + e.fantasy : ''} ${e.document ? e.document : ''
								} / ${e.address.address}${e.address.number ? ', ' + e.address.number : ''
								} - ${e.address.city}/${e.address.state}`,
						}
					})

					done(branches)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		searchPartner(terms, done) {
			this.$axios
				.get(`/admin_companies/branches/get_branches/?search=${terms}`, this.getHeader)
				.then((response) => {
					let partners = response.data.map((e) => {
						return {
							...e,
							value: e.id,
							label: `${e.name} ${e.fantasy ? ' / ' + e.fantasy : ''} ${e.document ? e.document : ''
								} / ${e.address.address}${e.address.number ? ', ' + e.address.number : ''
								} - ${e.address.city}/${e.address.state}`,
						}
					})

					done(partners)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectBranch(item, keyboard) {
			if (!keyboard) {
				this.company_branch_name = `${item.name} ${item.fantasy ? ' / ' + item.fantasy : ''
					} ${item.document ? ' - ' + item.document : ''}`
				this.company_branch_address = `${item.address.address}${item.address.number ? ', ' + item.address.number : ''
					} - ${item.address.city}/${item.address.state}`
				this.company_branch = item.id
			}
		},

		fetchHeadquarters(terms, done) {
			this.$axios
				.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
				.then((response) => {
					let headquarters = []

					response.data.forEach((element) => {
						headquarters.push({
							value: `${element.name} / ${this.$t(element.company_type_label)} ${element.document && element.register
								? `${element.document} - ${element.register}`
								: element.document
									? element.document
									: element.register
										? element.register
										: ''
								}`,
							label: `${element.name} / ${this.$t(element.company_type_label)} ${element.document && element.register
								? `${element.document} - ${element.register}`
								: element.document
									? element.document
									: element.register
										? element.register
										: ''
								}`,
							address: element.address,
							client: element.client,
							company_type: element.company_type,
							company_type_label: element.company_type_label,
							created_date: element.created_date,
							document: element.document,
							fantasy: element.fantasy,
							id: element.id,
							name: element.name,
							qty_branches: element.qty_branches,
							status: element.status,
							updated_date: element.updated_date,
						})
					})

					done(headquarters)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectHeadquarter(item) {
			let obj = this.companies.find((obj) => obj.id === item.id)
			if (!obj) {
				this.companies.push(item)
			}

			this.company.push(item.id)
			this.loadBranches()
		},

		selectPartner(item, keyboard) {
			if (!keyboard) {
				this.partner_name = `${item.name} ${item.fantasy ? ' / ' + item.fantasy : ''} ${item.document ? ' - ' + item.document : ''
					}`
				this.partner = item.id
			}
		},

		removeBranch() {
			this.company_branch_name = ''
			this.company_branch_address = ''
			this.company_branch = null
		},

		removePartner() {
			this.partner_name = ''
			this.partner = ''
		},

		removeHeadquarter({ index, value }) {
			this.company.splice(index, 1)
			this.branch = []
		},

		changeProducts() {
			this.$v.product_categories.$touch()
			this.products = this.products.filter((p) =>
				this.filteredProducts.find((fp) => {
					return fp.value === p
				})
			)
			if (this.current_client === 'academiacoral') this.selectAllProducts()
		},

		imageUploaded(url) {
			this.image_url_presential_event = url
		},

		certificateImageUploaded(url) {
			this.certificate_image_url = url
		},

		getEventTypeTooltip(ev) {
			return ev === 1
				? this.$t('open_training_rules_info')
				: this.$t('closed_training_rules_info')
		},

		getOrder(name) {
			if (name == 'cancel') {
				return this.$q.platform.is.mobile ? 'order-last' : 'order-first'
			} else if (name == 'save') {
				return this.$q.platform.is.mobile ? 'order-first' : 'order-last'
			}
		},

		updateParticipantsAndValidate() {
			this.qty_expected_participants = this.maximumParticipants
			this.$v.appointment_type_id.$touch
		},

		fetchTimezones() {
			let values = []

			moment.tz
				.names()
				.reduce((memo, tz) => {
					memo.push({
						name: tz,
						offset: moment.tz(tz).utcOffset(),
					})

					return memo
				}, [])
				.sort((a, b) => {
					return a.offset - b.offset
				})
				.reduce((memo, tz) => {
					const timezone = tz.offset ? moment.tz(tz.name).format('Z') : ''
					values.push({ value: tz.name, label: `(GMT${timezone}) ${tz.name}`, ...tz })
				}, '')

			this.$store.dispatch('registration_lists/SET_TIMEZONES', [values])
		},

		changeTimezone() {
			this.$emit('changeTimezone', this.timezone)
		},

		checkAll() {
			if (this.all_profiles) {
				this.profiles.forEach((element) => {
					this.profile.push(element.value)
				})
			} else {
				this.profile = []
			}
		},

		checkAllAreas() {
			if (this.all_areas) {
				this.area = this.areas.map((e) => e.value)
			} else {
				this.area = []
			}
		},

		checkAllCategories() {
			if (this.all_product_categories) {
				this.product_categories = this.product_categories_list.map((e) => e.value)
			} else {
				this.product_categories = []
			}
		},

		checkAllProducts() {
			if (this.all_products) {
				this.products = this.filteredProducts.map((e) => e.value)
			} else {
				this.products = []
			}
		},

		loadBranches() {
			let data = { company: this.company }

			this.$axios
				.get(
					`/presential/presential_events/list_branches/?${this.$qs.stringify(data, {
						arrayFormat: 'repeat',
					})}`,
					this.getHeader
				)
				.then((response) => {
					this.branches = response.data.map((e) => {
						return {
							...e,
							value: e.id,
							label: `${e.name} - ${e.address.address}${e.address.number ? ', ' + e.address.number : ''
								} - ${e.address.city}/${e.address.state}
                            ${e.branch_type_name ? `- ${e.branch_type_name}` : ''}`,
						}
					})

					if (
						this.current_client === 'universidadechevrolet' &&
						this.branch.length > 0 &&
						this.vacancies_qty.length === 0
					) {
						this.branch.forEach((b) => this.rebuildVacancies(b, 0))
					}
					if (
						this.current_client === 'universidadechevrolet' &&
						this.branch.length > 0 &&
						this.vacancies_qty.length > 0
					) {
						this.branch.forEach((b, i) =>
							this.rebuildVacancies(b, this.vacancies_qty[i])
						)
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},

		getErrorClass(state) {
			return state ? 'checkbox-error' : ''
		},

		getErrorColor(state) {
			return state ? 'negative' : ''
		},

		searchCode() {
			if (this.code) {
				this.loading_code = true
				this.$axios
					.get(
						`/presential/presential_events/list_presential_event_code/?code=${this.code
						}`,
						this.getHeader
					)
					.then((response) => {
						this.loading_code = false
						this.trainings_code = response.data.map((e, index) => {
							return {
								index: index,
								title: e.title,
							}
						})
					})
					.catch((e) => {
						console.log(e)
					})
			}
		},

		copyLink() {
			this.$copyText(this.url_presential_training).then(
				(e) => {
					this.$q.notify({
						message: this.$t('link_copied_to_clipboard'),
						type: 'positive',
						icon: 'fal fa-copy',
					})
				},
				(e) => {
					console.log(e)
				}
			)
		},

		selectAllProducts() {
			if (this.product_categories.length > 0) {
				this.all_products = true
				this.products = this.filteredProducts.map((e) => e.value)
			} else {
				this.all_products = false
				this.products = []
			}
		},

		addVacancies(branches_ids) {
			let branchObj = this.branches.find(
				(b) => b.id === branches_ids[branches_ids.length - 1]
			)
			if (branchObj) {
				let branchToAdd = {
					label: branchObj.label,
					branch: branchObj.id,
					qty_vacancies: 0,
				}
				this.vacancies.push(branchToAdd)
			}

			if (branches_ids.length <= 0) {
				this.vacancies = []
			} else if (branches_ids.length !== this.vacancies.length) {
				let newVacancies = []
				branches_ids.forEach((i) => {
					let branch = this.branches.find((b) => i === b.id)
					if (branch) {
						let branchToAdd = {
							label: branch.label,
							branch: branch.id,
							qty_vacancies: 0,
						}
						newVacancies.push(branchToAdd)
					}
				})
				this.vacancies = newVacancies
			}
		},

		rebuildVacancies(branch, qty) {
			let branchObj = this.branches.find((b) => b.id === branch)
			if (branchObj) {
				let branchToAdd = {
					label: branchObj.label,
					branch: branchObj.id,
					qty_vacancies: qty,
				}
				this.vacancies.push(branchToAdd)
			}
		},

		checkVacancies() {
			let usedVacancies = this.vacancies.reduce((acc, branch) => {
				return acc + branch.qty_vacancies
			}, 0)
			this.vacancies_used = usedVacancies

			if (this.vacancies_used === 0) return true

			if (usedVacancies > this.qty_expected_participants) {
				return false
			} else {
				if (usedVacancies === this.qty_expected_participants) {
					return true
				} else return false
			}
		},

		checkUserAllowed() {
			if (!this.permissions.view_pre_scheduled_training) {
				this.$q.notify({
					message: this.$t('permission_denied'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
				})

				this.$router.push({ name: 'appointments' })
			}
		},

		coralCheckSave(appointment) {
			if (appointment === 17) {
				this.$refs.appointment_type_id.$el.focus()
				this.$q.notify({
					message: this.$t('please_change_appointment_type'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
				})
				this.$emit('AcademiaCoralApprovalHandler', false)
				return false
			} else if (
				this.instructors_labels.find(
					(e) => e === '[CONSULTOR: SELECIONAR] - selecione-seu-nome@ac.com.br'
				)
			) {
				this.$refs.instructors_labels.$el.focus()
				this.$q.notify({
					message: this.$t('please_select_instructor'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
				})
				this.$emit('AcademiaCoralApprovalHandler', false)
				return false
			} else {
				this.$emit('AcademiaCoralApprovalHandler', true)
				return true
			}
		},

		fetchCatalogCodes(terms, done) {
			this.$axios
				.get(`/presential_manager/presential_catalogs/?search=${terms}`, this.getHeader)
				.then((response) => {
					let codes = response.data.map((e) => ({
						...e,
						value: e.id,
						label: `${e.code} - ${e.title}`,
					}))

					done(codes)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectCatalogCode(item) {
			this.presential_event_catalog = item.id
			this.presential_event_catalog_code = item.code
			this.presential_event_catalog_title = item.title

			this.code = item.code
			this.title = item.title
			this.description = item.description
			this.product_categories = item.product_categories
			this.products = item.products
			this.tags = item.tags
			this.qty_days = item.qty_certificate_expiration_days
			this.profile = item.profiles
			this.area = item.areas
		},

		removeCatalogCode() {
			this.presential_event_catalog = ''
			this.presential_event_catalog_code = ''
			this.presential_event_catalog_title = ''
		},
		renderPresentialEventCatalogCode() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			return client.presential_event_catalog
		},

		fnInDays(value) {
			this.qty_days_result_expiration = value
		},

		insertImg() {
			const input = document.createElement('input')
			input.type = 'file'
			input.accept = '.png, .jpg, .gif'
			let file

			input.onchange = (_) => {
				const files = Array.from(input.files)
				file = files[0]

				this.uploadFile(file)
			}
			input.click()
		},
	},

	created() {
		this.save_as_model = false
		this.fetchTimezones()
		this.id = this.$route.params.id
		if (this.id != 0) {
			this.fetchData()
		} else {
			this.user_requester_name_email = `${this.name_store} - ${this.email_store}`
			this.timezone = moment.tz.guess()
			this.changeTimezone()
			this.autoSelectInstructor(this.full_name)
		}
		let client = this.clients.find((obj) => {
			return obj.id === this.id_user_client_selected
		})
		this.selected_client_params = client ? client : {}
	},

	watch: {
		$route: function (refreshPage) {
			this.fetchTimezones()
			this.id = this.$route.params.id

			if (this.id != 0) {
				this.fetchData()
			} else {
				this.timezone = moment.tz.guess()
				this.changeTimezone()
			}
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			this.selected_client_params = client ? client : {}
		},
	},

	validations() {
		return {
			presential_event_catalog_code: {
				requiredIf: requiredIf(() => {
					if (process.env.PROJECT_FOLDER === 'universidadechevrolet') return true
					else return false
				}),
			},
			appointment_type_id: { required },
			title: { required, maxLength: maxLength(256) },
			language_br: { maxLength: maxLength(256) },
			language_us: { maxLength: maxLength(256) },
			language_es: { maxLength: maxLength(256) },
			language_fr: { maxLength: maxLength(256) },
			descriptionWithoutHTML: { required, maxLength: maxLength(1024) },
			instructors: { required },
			company_branch: { required },
			product_categories: { required },
			products: { required },
			qty_expected_participants: {
				required,
				minValue: minValue(1),
			},
			presential_event_type: required,
			score: { minValue: minValue(0) },
			workload: {
				required,
				minValue:
					this.current_client === 'universidadechevrolet' ? minValue(1) : minValue(0),
			},
			area: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0 &&
						this.company == 0 &&
						this.branch
					) {
						return true
					} else {
						if (this.profile.length > 0 && this.area.length == 0) return true
						else return false
					}
				}),
			},
			profile: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0 &&
						this.company == 0 &&
						this.branch
					) {
						return true
					} else {
						if (this.area.length > 0 && this.profile.length == 0) return true
						else return false
					}
				}),
			},
			user_group: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0 &&
						this.company == 0 &&
						this.branch
					) {
						return true
					} else {
						return false
					}
				}),
			},
			branch: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0 &&
						this.company == 0 &&
						this.branch
					) {
						return true
					} else {
						if (this.company.length > 0 && this.branch.length == 0) return true
						else return false
					}
				}),
			},
			company: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0 &&
						this.company == 0 &&
						this.branch
					) {
						return true
					} else {
						if (this.branch.length > 0 && this.company.length == 0) return true
						else return false
					}
				}),
			},
		}
	},
}
</script>

<style lang="stylus" scoped>
.event-card
    box-shadow 0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)

.custom-tooltip
    width 450px
    font-size 0.9rem
    padding 0.8rem

.custom-input
    text-transform capitalize
    input
        text-align right
</style>
